import { jsx as _jsx } from "react/jsx-runtime";
import { useState } from 'react';
import UIIcon from 'UIComponents/icon/UIIcon';
import styled, { theme, useMediaQuery } from '../../../utils/Styling';
import { DesktopCardMenu, MobileCardMenu } from '..';
import getLang from 'I18n/utils/getLang';
const StyledMenuIcon = styled(UIIcon).withConfig({
  displayName: "CardMenuIcon__StyledMenuIcon",
  componentId: "bw3ys8-0"
})(["font-size:20px;border-radius:100%;width:26px;height:26px;display:flex !important;align-items:center;justify-content:center;padding-top:3px;cursor:pointer;color:", ";background:", ";"], ({
  use
}) => use === 'on-dark' ? theme.colors.OLAF : theme.colors.EERIE, ({
  use
}) => use === 'on-dark' ? 'rgba(0, 0, 0, 0.3)' : 'none');

const MenuIcon = ({
  use,
  onClick
}) => /*#__PURE__*/_jsx(StyledMenuIcon, {
  className: "card-menu-icon",
  "data-test-id": "card-menu-popover-button",
  name: "verticalMenu",
  onClick: onClick,
  use: use
});

const CardMenuIcon = props => {
  const [isOpen, setIsOpen] = useState(false);

  const onIconClick = e => {
    e.preventDefault();
    setIsOpen(true);
  };

  const handleOnOpenChange = newIsOpenValue => setIsOpen(newIsOpenValue);

  const {
    isMobile
  } = useMediaQuery();
  const Component = isMobile ? MobileCardMenu : DesktopCardMenu;
  const {
    use = 'on-light',
    language = getLang()
  } = props;
  return /*#__PURE__*/_jsx("div", {
    onClick: e => e.stopPropagation(),
    children: /*#__PURE__*/_jsx(Component, Object.assign({}, props, {
      isOpen: isOpen,
      language: language,
      onOpenChange: handleOnOpenChange,
      use: use,
      children: /*#__PURE__*/_jsx(MenuIcon, {
        onClick: onIconClick,
        use: use
      })
    }))
  });
};

export default CardMenuIcon;